import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/notifications//flag-img.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3fd4ad27"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-notification-sm relative",
  "data-test": "notifications-trigger-button",
  "data-role": "trigger",
  "aria-label": "Notifications"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "notification-heading" }, "Notifications")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  role: "separator",
  class: "divider"
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "notification-heading"
}
const _hoisted_5 = {
  key: 0,
  class: "notification-heading"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  role: "separator",
  class: "divider"
}, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "end-notifications" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "text-center",
    "data-test": "all-loaded"
  }, " That's all for your notifications from the last 30 days. "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "all notifications loaded",
    class: "all-loaded-img"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "notification-error" }

import { nextTick, onMounted, onUnmounted, ref, watch, watchEffect, computed } from "vue";
import { Dropdown } from "uiv";
import dayjs from "dayjs";
import useNotification from "../../composables/useNotification";
import {
  NotificationApiModel,
  NotificationStatusApiModel,
  PaginatedResponseApiModel,
} from "../../api-models";
import { csContext } from "../../services/cs-context";
import NotificationItem from "./notification-item.vue";

const INITIAL_PAGE = 1;
const PAGE_SIZE = 10;


export default /*#__PURE__*/_defineComponent({
  __name: 'user-notifications-dropdown',
  setup(__props) {

const userId = csContext.user.id;

const { getNotificationsForUser, updateStatus } = useNotification();

const notifications = ref<PaginatedResponseApiModel<NotificationApiModel>>();
const allNotificationsLoaded = ref(false);
const loading = ref(false);
const error = ref("");

const notificationsRef = ref<HTMLElement[]>();

const recentNotifications = computed(() => {
  const twoDaysAgo = dayjs().subtract(2, "day");

  if (notifications.value) {
    return notifications.value.items.filter((n) => {
      return dayjs(n.createdDate).isAfter(twoDaysAgo);
    });
  }
  return [];
});

const olderNotifications = computed(() => {
  const twoDaysAgo = dayjs().subtract(2, "day");

  if (notifications.value) {
    return notifications.value.items.filter((n) => {
      return dayjs(n.createdDate).isBefore(twoDaysAgo);
    });
  }
  return [];
});

const fetchNotifications = async (pageNumber: number, pageSize?: number) => {
  const pageSizeToUse = pageSize || PAGE_SIZE;
  const newNotifications = await getNotificationsForUser(userId, pageNumber, pageSizeToUse);
  if (notifications.value) {
    notifications.value.items.push(...newNotifications.items);
  } else {
    notifications.value = newNotifications;
  }

  nextTick(() => {
    if (notifications.value && notifications.value.items.length >= notifications.value.totalCount) {
      allNotificationsLoaded.value = true;
    }
  });
};

const updateStatusAndRefetchData = async (
  notification: NotificationApiModel,
  newStatus: NotificationStatusApiModel,
) => {
  const response = await updateStatus(notification.id, newStatus);
  if (response.success) {
    // refresh current notifications
    const currentNotificationCount = notifications.value?.items.length || 0;
    notifications.value = await getNotificationsForUser(
      userId,
      INITIAL_PAGE,
      currentNotificationCount,
    );
  }
};

const uncompletedActionNotifications = computed(() => {
  if (!notifications.value) {
    return "0";
  }

  const uncompleted = notifications.value.items.filter(
    (n) => n.actionStatus === "Uncompleted" || n.status === "Unread",
  );

  if (uncompleted.length === 0) {
    return "0";
  }

  if (uncompleted.length > 9) {
    return "9+";
  }

  return uncompleted.length.toString();
});

const observer = ref();

// Intersection Observer callback
const observerCallback = (entries) => {
  const lastEntry = entries[0];
  if (
    lastEntry.isIntersecting &&
    !allNotificationsLoaded.value &&
    !loading.value &&
    notifications.value
  ) {
    const nextPage = Math.ceil(notifications.value.items.length / PAGE_SIZE) + 1;
    fetchNotifications(nextPage);
  }
};

// Set the ref for the second-to-last notification
const setNotificationRef = (el: HTMLElement, index: number) => {
  if (notifications.value && index === notifications.value.items.length - 2) {
    if (observer.value) {
      observer.value.disconnect(); // Disconnect the previous observer
    }
    if (el) {
      observer.value.observe(el); // Observe the new second-to-last notification
    }
  }
};

// Watch for changes in the notifications list
watchEffect(() => {
  if (notifications.value && notificationsRef.value && notifications.value.items.length > 1) {
    const secondToLastIndex = notifications.value.items.length - 2;
    const secondToLastNotification = notificationsRef.value[secondToLastIndex];
    // We need to make sure the DOM is updated before we can assign the ref
    nextTick(() => {
      setNotificationRef(secondToLastNotification, secondToLastIndex);
    });
  }
});

watch(notifications, () => {
  if (notifications.value && notifications.value.page === 0) {
    error.value = "There was an error loading your notifications. Please try again later.";
  }
});

// Set up the Intersection Observer
onMounted(() => {
  observer.value = new IntersectionObserver(observerCallback, {
    threshold: 0.5,
  });

  fetchNotifications(INITIAL_PAGE);
});

onUnmounted(() => {
  if (observer.value) {
    observer.value.disconnect();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dropdown), {
    class: "edit-dropdown user-notifications",
    "menu-right": ""
  }, _createSlots({
    default: _withCtx(() => [
      _hoisted_1,
      _withDirectives(_createElementVNode("div", {
        class: "notification-badge",
        "data-test": "action-notification-count"
      }, _toDisplayString(uncompletedActionNotifications.value), 513), [
        [_vShow, uncompletedActionNotifications.value !== '0']
      ])
    ]),
    _: 2
  }, [
    (!error.value.length)
      ? {
          name: "dropdown",
          fn: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("li", null, [
              (recentNotifications.value.length)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_4, "RECENT"))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentNotifications.value, (notification) => {
              return (_openBlock(), _createElementBlock("li", {
                key: notification.id,
                ref_for: true,
                ref_key: "notificationsRef",
                ref: notificationsRef,
                "data-test": "recent-notifications"
              }, [
                _createVNode(NotificationItem, {
                  notification: notification,
                  onUpdateStatus: updateStatusAndRefetchData
                }, null, 8, ["notification"])
              ]))
            }), 128)),
            _createElementVNode("li", null, [
              (olderNotifications.value.length)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_5, "OLDER"))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(olderNotifications.value, (notification) => {
              return (_openBlock(), _createElementBlock("li", {
                key: notification.id,
                ref_for: true,
                ref_key: "notificationsRef",
                ref: notificationsRef,
                "data-test": "older-notifications"
              }, [
                _createVNode(NotificationItem, {
                  notification: notification,
                  onUpdateStatus: updateStatusAndRefetchData
                }, null, 8, ["notification"])
              ]))
            }), 128)),
            _hoisted_6,
            (allNotificationsLoaded.value)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          key: "0"
        }
      : {
          name: "dropdown",
          fn: _withCtx(() => [
            _createElementVNode("li", _hoisted_10, _toDisplayString(error.value), 1)
          ]),
          key: "1"
        }
  ]), 1024))
}
}

})